import { durationComparator } from '@components/Sorting/Provider';
import { createBestItineraryData } from './createBestItineraryData';

const FastestItineraryBuilder = () => {
  let fastestPosition;
  let fastest = {
    duration: Infinity,
  };

  return {
    add(itinerary, position) {
      if (durationComparator(itinerary, fastest) < 0) {
        fastest = itinerary;
        fastestPosition = position;
      }
    },
    build() {
      return createBestItineraryData('fastest', fastest, fastestPosition);
    },
  };
};

export default FastestItineraryBuilder;
